
<p class="title pl-5 pb-0">TABLERO DE SEGUIMIENTO</p>
@for (tema of temas; track tema.id) {
<div class="m-5 mb-0 pb-5">
    <mat-card>
        <mat-card-header>
            <mat-card-title class="!p-0">{{tema.nombre}}</mat-card-title>
            <div class="header-button">
                <button type="button" mat-flat-button color="primary" (click)="descargaReporte(tema)" [disabled]="!tema.descargaReporte">DESCARGAR</button>
            </div>
        </mat-card-header>
        <mat-card-content class="mt-5">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon_a_tiempo">thumb_up</mat-icon>
                        A TIEMPO ({{tema.vigentes.length}})
                    </ng-template>
                    <div class="w-full">
                        @for (item of tema.vigentes; track item.id) {
                            <div class="flex flex-row items-center item-entrada" (click)="verEntrada(item)">
                                <div class="flex-90 pl-5">
                                    <span matListItemLine><b>Asunto:        </b> {{ item.asunto }}                           </span>
                                    <span matListItemLine><b>Empresa:       </b> {{ item.empresa_descripcion }}              </span>
                                    <span matListItemLine><b>Justificación: </b> {{ item.justificacion }}                    </span>
                                    <span matListItemLine><b>Prioridad:     </b> {{ item.prioridad }}                        </span>
                                    <span matListItemLine><b>Fecha Inicio:  </b> {{ item.fechaInicio | date:'dd/MM/yyyy' }}  </span>
                                    <span matListItemLine><b>Fecha Fin:     </b> {{ item.fechaFin | date:'dd/MM/yyyy' }}     </span>
                                    <span matListItemLine><b>Tipo:          </b> {{ item.tipo_descripcion }}                 </span>
                                </div>
                                <!--div class="flex-auto text-right">
                                    <button type="button" mat-stroked-button color="primary" (click)="verEntrada(item)">VER DETALLE</button>
                                </!--div-->
                            </div>
                            @if(!$last) { <mat-divider></mat-divider> }
                        }
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon_por_vencer">thumbs_up_down</mat-icon>
                        POR VENCER ({{tema.xvencer.length}})
                    </ng-template>
                    <div class="w-full">
                        @for (item of tema.xvencer; track item.id) {
                            <div class="flex flex-row items-center item-entrada" (click)="verEntrada(item)">
                                <div class="flex-90 pl-5">
                                    <span matListItemLine><b>Asunto:        </b> {{ item.asunto }}                           </span>
                                    <span matListItemLine><b>Empresa:       </b> {{ item.empresa_descripcion }}              </span>
                                    <span matListItemLine><b>Justificación: </b> {{ item.justificacion }}                    </span>
                                    <span matListItemLine><b>Prioridad:     </b> {{ item.prioridad }}                        </span>
                                    <span matListItemLine><b>Fecha Inicio:  </b> {{ item.fechaInicio | date:'dd/MM/yyyy' }}  </span>
                                    <span matListItemLine><b>Fecha Fin:     </b> {{ item.fechaFin | date:'dd/MM/yyyy' }}     </span>
                                    <span matListItemLine><b>Tipo:          </b> {{ item.tipo_descripcion }}                 </span>
                                </div>
                                <!--div class="flex-auto text-right">
                                    <button type="button" mat-stroked-button color="primary" (click)="verEntrada(item)">VER DETALLE</button>
                                </!--div-->
                            </div>
                            @if(!$last) { <mat-divider></mat-divider> }
                        }
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon_vencidos">thumb_down</mat-icon>
                        VENCIDOS ({{tema.vencidas.length}})
                    </ng-template>
                    <div class="w-full">
                        @for (item of tema.vencidas; track item.id) {
                            <div class="flex flex-row items-center item-entrada" (click)="verEntrada(item)">
                                <div class="flex-90 pl-5">
                                    <span matListItemLine><b>Asunto:        </b> {{ item.asunto }}                           </span>
                                    <span matListItemLine><b>Empresa:       </b> {{ item.empresa_descripcion }}              </span>
                                    <span matListItemLine><b>Justificación: </b> {{ item.justificacion }}                    </span>
                                    <span matListItemLine><b>Prioridad:     </b> {{ item.prioridad }}                        </span>
                                    <span matListItemLine><b>Fecha Inicio:  </b> {{ item.fechaInicio | date:'dd/MM/yyyy' }}  </span>
                                    <span matListItemLine><b>Fecha Fin:     </b> {{ item.fechaFin | date:'dd/MM/yyyy' }}     </span>
                                    <span matListItemLine><b>Tipo:          </b> {{ item.tipo_descripcion }}                 </span>
                                </div>
                                <!--div class="flex-auto text-right">
                                    <button type="button" mat-stroked-button color="primary" (click)="verEntrada(item)">VER DETALLE</button>
                                </!--div-->
                            </div>
                            @if(!$last) { <mat-divider></mat-divider> }
                        }
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>        
    </mat-card>
    @if(progress_mode == 'indeterminate') {
        <mat-progress-bar class="rounded-b-lg" [mode]="progress_mode" [color]="progress_color" value="100"></mat-progress-bar>
    }
</div>
}